/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotTaskAvailableResponse,
  ApiEnvelopeBotTaskCancelResponse,
  ApiEnvelopeBotTaskHistoryPageResponse,
  ApiEnvelopeBotTaskOptionListResponse,
  ApiEnvelopeBotTaskPauseResponse,
  ApiEnvelopeBotTaskQueueIdResponse,
  ApiEnvelopeBotTaskResumeResponse,
  ApiEnvelopeBotTaskStatusResponse,
  BotTaskExportTaskTranscriptParams,
  BotTaskGetTaskHistoryParams,
  ProblemDetails,
  RunBotTaskRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botTaskGetAvailableTasksResponse200 = {
  data: ApiEnvelopeBotTaskAvailableResponse
  status: 200
}

export type botTaskGetAvailableTasksResponse401 = {
  data: ApiEnvelopeBotTaskAvailableResponse
  status: 401
}

export type botTaskGetAvailableTasksResponse403 = {
  data: ApiEnvelopeBotTaskAvailableResponse
  status: 403
}

export type botTaskGetAvailableTasksResponse404 = {
  data: ApiEnvelopeBotTaskAvailableResponse
  status: 404
}

export type botTaskGetAvailableTasksResponseSuccess = (botTaskGetAvailableTasksResponse200) & {
  headers: Headers;
};
export type botTaskGetAvailableTasksResponseError = (botTaskGetAvailableTasksResponse401 | botTaskGetAvailableTasksResponse403 | botTaskGetAvailableTasksResponse404) & {
  headers: Headers;
};

export type botTaskGetAvailableTasksResponse = (botTaskGetAvailableTasksResponseSuccess | botTaskGetAvailableTasksResponseError)

export const getBotTaskGetAvailableTasksUrl = (botId: string,) => {




  return `/api/botengine/${botId}/tasks`
}

export const useBotTaskGetAvailableTasksHook = (): (botId: string, options?: RequestInit) => Promise<botTaskGetAvailableTasksResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotTaskGetAvailableTasksUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botTaskGetParameterOptionsResponse200 = {
  data: ApiEnvelopeBotTaskOptionListResponse
  status: 200
}

export type botTaskGetParameterOptionsResponse400 = {
  data: ApiEnvelopeBotTaskOptionListResponse
  status: 400
}

export type botTaskGetParameterOptionsResponse401 = {
  data: ApiEnvelopeBotTaskOptionListResponse
  status: 401
}

export type botTaskGetParameterOptionsResponse403 = {
  data: ApiEnvelopeBotTaskOptionListResponse
  status: 403
}

export type botTaskGetParameterOptionsResponse404 = {
  data: ApiEnvelopeBotTaskOptionListResponse
  status: 404
}

export type botTaskGetParameterOptionsResponseSuccess = (botTaskGetParameterOptionsResponse200) & {
  headers: Headers;
};
export type botTaskGetParameterOptionsResponseError = (botTaskGetParameterOptionsResponse400 | botTaskGetParameterOptionsResponse401 | botTaskGetParameterOptionsResponse403 | botTaskGetParameterOptionsResponse404) & {
  headers: Headers;
};

export type botTaskGetParameterOptionsResponse = (botTaskGetParameterOptionsResponseSuccess | botTaskGetParameterOptionsResponseError)

export const getBotTaskGetParameterOptionsUrl = (botId: string,
    source: string,) => {




  return `/api/botengine/${botId}/tasks/options/${source}`
}

export const useBotTaskGetParameterOptionsHook = (): (botId: string,
    source: string, options?: RequestInit) => Promise<botTaskGetParameterOptionsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    source: string, options?: RequestInit) => {

        return customFetcher(getBotTaskGetParameterOptionsUrl(botId,source),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botTaskRunTaskResponse200 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 200
}

export type botTaskRunTaskResponse400 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 400
}

export type botTaskRunTaskResponse401 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 401
}

export type botTaskRunTaskResponse403 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 403
}

export type botTaskRunTaskResponse404 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 404
}

export type botTaskRunTaskResponseSuccess = (botTaskRunTaskResponse200) & {
  headers: Headers;
};
export type botTaskRunTaskResponseError = (botTaskRunTaskResponse400 | botTaskRunTaskResponse401 | botTaskRunTaskResponse403 | botTaskRunTaskResponse404) & {
  headers: Headers;
};

export type botTaskRunTaskResponse = (botTaskRunTaskResponseSuccess | botTaskRunTaskResponseError)

export const getBotTaskRunTaskUrl = (botId: string,) => {




  return `/api/botengine/${botId}/tasks/run`
}

export const useBotTaskRunTaskHook = (): (botId: string,
    runBotTaskRequest?: RunBotTaskRequest, options?: RequestInit) => Promise<botTaskRunTaskResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    runBotTaskRequest?: RunBotTaskRequest, options?: RequestInit) => {

        return customFetcher(getBotTaskRunTaskUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runBotTaskRequest)
  }
);
      }
  }


export type botTaskEnqueueTaskResponse200 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 200
}

export type botTaskEnqueueTaskResponse400 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 400
}

export type botTaskEnqueueTaskResponse401 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 401
}

export type botTaskEnqueueTaskResponse403 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 403
}

export type botTaskEnqueueTaskResponse404 = {
  data: ApiEnvelopeBotTaskQueueIdResponse
  status: 404
}

export type botTaskEnqueueTaskResponseSuccess = (botTaskEnqueueTaskResponse200) & {
  headers: Headers;
};
export type botTaskEnqueueTaskResponseError = (botTaskEnqueueTaskResponse400 | botTaskEnqueueTaskResponse401 | botTaskEnqueueTaskResponse403 | botTaskEnqueueTaskResponse404) & {
  headers: Headers;
};

export type botTaskEnqueueTaskResponse = (botTaskEnqueueTaskResponseSuccess | botTaskEnqueueTaskResponseError)

export const getBotTaskEnqueueTaskUrl = (botId: string,) => {




  return `/api/botengine/${botId}/tasks/enqueue`
}

export const useBotTaskEnqueueTaskHook = (): (botId: string,
    runBotTaskRequest?: RunBotTaskRequest, options?: RequestInit) => Promise<botTaskEnqueueTaskResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    runBotTaskRequest?: RunBotTaskRequest, options?: RequestInit) => {

        return customFetcher(getBotTaskEnqueueTaskUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runBotTaskRequest)
  }
);
      }
  }


export type botTaskCancelTaskResponse200 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 200
}

export type botTaskCancelTaskResponse400 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 400
}

export type botTaskCancelTaskResponse401 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 401
}

export type botTaskCancelTaskResponse403 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 403
}

export type botTaskCancelTaskResponse404 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 404
}

export type botTaskCancelTaskResponseSuccess = (botTaskCancelTaskResponse200) & {
  headers: Headers;
};
export type botTaskCancelTaskResponseError = (botTaskCancelTaskResponse400 | botTaskCancelTaskResponse401 | botTaskCancelTaskResponse403 | botTaskCancelTaskResponse404) & {
  headers: Headers;
};

export type botTaskCancelTaskResponse = (botTaskCancelTaskResponseSuccess | botTaskCancelTaskResponseError)

export const getBotTaskCancelTaskUrl = (botId: string,) => {




  return `/api/botengine/${botId}/tasks/cancel`
}

export const useBotTaskCancelTaskHook = (): (botId: string, options?: RequestInit) => Promise<botTaskCancelTaskResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotTaskCancelTaskUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botTaskPauseTaskResponse200 = {
  data: ApiEnvelopeBotTaskPauseResponse
  status: 200
}

export type botTaskPauseTaskResponse401 = {
  data: ApiEnvelopeBotTaskPauseResponse
  status: 401
}

export type botTaskPauseTaskResponse403 = {
  data: ApiEnvelopeBotTaskPauseResponse
  status: 403
}

export type botTaskPauseTaskResponse404 = {
  data: ApiEnvelopeBotTaskPauseResponse
  status: 404
}

export type botTaskPauseTaskResponse409 = {
  data: ApiEnvelopeBotTaskPauseResponse
  status: 409
}

export type botTaskPauseTaskResponseSuccess = (botTaskPauseTaskResponse200) & {
  headers: Headers;
};
export type botTaskPauseTaskResponseError = (botTaskPauseTaskResponse401 | botTaskPauseTaskResponse403 | botTaskPauseTaskResponse404 | botTaskPauseTaskResponse409) & {
  headers: Headers;
};

export type botTaskPauseTaskResponse = (botTaskPauseTaskResponseSuccess | botTaskPauseTaskResponseError)

export const getBotTaskPauseTaskUrl = (botId: string,) => {




  return `/api/botengine/${botId}/tasks/pause`
}

export const useBotTaskPauseTaskHook = (): (botId: string, options?: RequestInit) => Promise<botTaskPauseTaskResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotTaskPauseTaskUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botTaskResumeTaskResponse200 = {
  data: ApiEnvelopeBotTaskResumeResponse
  status: 200
}

export type botTaskResumeTaskResponse401 = {
  data: ApiEnvelopeBotTaskResumeResponse
  status: 401
}

export type botTaskResumeTaskResponse403 = {
  data: ApiEnvelopeBotTaskResumeResponse
  status: 403
}

export type botTaskResumeTaskResponse404 = {
  data: ApiEnvelopeBotTaskResumeResponse
  status: 404
}

export type botTaskResumeTaskResponse409 = {
  data: ApiEnvelopeBotTaskResumeResponse
  status: 409
}

export type botTaskResumeTaskResponseSuccess = (botTaskResumeTaskResponse200) & {
  headers: Headers;
};
export type botTaskResumeTaskResponseError = (botTaskResumeTaskResponse401 | botTaskResumeTaskResponse403 | botTaskResumeTaskResponse404 | botTaskResumeTaskResponse409) & {
  headers: Headers;
};

export type botTaskResumeTaskResponse = (botTaskResumeTaskResponseSuccess | botTaskResumeTaskResponseError)

export const getBotTaskResumeTaskUrl = (botId: string,) => {




  return `/api/botengine/${botId}/tasks/resume`
}

export const useBotTaskResumeTaskHook = (): (botId: string, options?: RequestInit) => Promise<botTaskResumeTaskResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotTaskResumeTaskUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botTaskGetTaskStatusResponse200 = {
  data: ApiEnvelopeBotTaskStatusResponse
  status: 200
}

export type botTaskGetTaskStatusResponse401 = {
  data: ApiEnvelopeBotTaskStatusResponse
  status: 401
}

export type botTaskGetTaskStatusResponse403 = {
  data: ApiEnvelopeBotTaskStatusResponse
  status: 403
}

export type botTaskGetTaskStatusResponse404 = {
  data: ApiEnvelopeBotTaskStatusResponse
  status: 404
}

export type botTaskGetTaskStatusResponseSuccess = (botTaskGetTaskStatusResponse200) & {
  headers: Headers;
};
export type botTaskGetTaskStatusResponseError = (botTaskGetTaskStatusResponse401 | botTaskGetTaskStatusResponse403 | botTaskGetTaskStatusResponse404) & {
  headers: Headers;
};

export type botTaskGetTaskStatusResponse = (botTaskGetTaskStatusResponseSuccess | botTaskGetTaskStatusResponseError)

export const getBotTaskGetTaskStatusUrl = (botId: string,) => {




  return `/api/botengine/${botId}/tasks/status`
}

export const useBotTaskGetTaskStatusHook = (): (botId: string, options?: RequestInit) => Promise<botTaskGetTaskStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotTaskGetTaskStatusUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botTaskGetTaskHistoryResponse200 = {
  data: ApiEnvelopeBotTaskHistoryPageResponse
  status: 200
}

export type botTaskGetTaskHistoryResponse401 = {
  data: ApiEnvelopeBotTaskHistoryPageResponse
  status: 401
}

export type botTaskGetTaskHistoryResponse403 = {
  data: ApiEnvelopeBotTaskHistoryPageResponse
  status: 403
}

export type botTaskGetTaskHistoryResponse404 = {
  data: ApiEnvelopeBotTaskHistoryPageResponse
  status: 404
}

export type botTaskGetTaskHistoryResponseSuccess = (botTaskGetTaskHistoryResponse200) & {
  headers: Headers;
};
export type botTaskGetTaskHistoryResponseError = (botTaskGetTaskHistoryResponse401 | botTaskGetTaskHistoryResponse403 | botTaskGetTaskHistoryResponse404) & {
  headers: Headers;
};

export type botTaskGetTaskHistoryResponse = (botTaskGetTaskHistoryResponseSuccess | botTaskGetTaskHistoryResponseError)

export const getBotTaskGetTaskHistoryUrl = (botId: string,
    params?: BotTaskGetTaskHistoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/${botId}/tasks/history?${stringifiedParams}` : `/api/botengine/${botId}/tasks/history`
}

export const useBotTaskGetTaskHistoryHook = (): (botId: string,
    params?: BotTaskGetTaskHistoryParams, options?: RequestInit) => Promise<botTaskGetTaskHistoryResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: BotTaskGetTaskHistoryParams, options?: RequestInit) => {

        return customFetcher(getBotTaskGetTaskHistoryUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botTaskCancelQueuedTaskResponse200 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 200
}

export type botTaskCancelQueuedTaskResponse400 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 400
}

export type botTaskCancelQueuedTaskResponse401 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 401
}

export type botTaskCancelQueuedTaskResponse403 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 403
}

export type botTaskCancelQueuedTaskResponse404 = {
  data: ApiEnvelopeBotTaskCancelResponse
  status: 404
}

export type botTaskCancelQueuedTaskResponseSuccess = (botTaskCancelQueuedTaskResponse200) & {
  headers: Headers;
};
export type botTaskCancelQueuedTaskResponseError = (botTaskCancelQueuedTaskResponse400 | botTaskCancelQueuedTaskResponse401 | botTaskCancelQueuedTaskResponse403 | botTaskCancelQueuedTaskResponse404) & {
  headers: Headers;
};

export type botTaskCancelQueuedTaskResponse = (botTaskCancelQueuedTaskResponseSuccess | botTaskCancelQueuedTaskResponseError)

export const getBotTaskCancelQueuedTaskUrl = (botId: string,
    queueId: string,) => {




  return `/api/botengine/${botId}/tasks/queue/${queueId}/cancel`
}

export const useBotTaskCancelQueuedTaskHook = (): (botId: string,
    queueId: string, options?: RequestInit) => Promise<botTaskCancelQueuedTaskResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    queueId: string, options?: RequestInit) => {

        return customFetcher(getBotTaskCancelQueuedTaskUrl(botId,queueId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botTaskExportTaskTranscriptResponse200 = {
  data: Blob
  status: 200
}

export type botTaskExportTaskTranscriptResponse401 = {
  data: ProblemDetails
  status: 401
}

export type botTaskExportTaskTranscriptResponse403 = {
  data: ProblemDetails
  status: 403
}

export type botTaskExportTaskTranscriptResponse404 = {
  data: ProblemDetails
  status: 404
}

export type botTaskExportTaskTranscriptResponseSuccess = (botTaskExportTaskTranscriptResponse200) & {
  headers: Headers;
};
export type botTaskExportTaskTranscriptResponseError = (botTaskExportTaskTranscriptResponse401 | botTaskExportTaskTranscriptResponse403 | botTaskExportTaskTranscriptResponse404) & {
  headers: Headers;
};

export type botTaskExportTaskTranscriptResponse = (botTaskExportTaskTranscriptResponseSuccess | botTaskExportTaskTranscriptResponseError)

export const getBotTaskExportTaskTranscriptUrl = (botId: string,
    taskId: string,
    params?: BotTaskExportTaskTranscriptParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/botengine/${botId}/tasks/history/${taskId}/export?${stringifiedParams}` : `/api/botengine/${botId}/tasks/history/${taskId}/export`
}

export const useBotTaskExportTaskTranscriptHook = (): (botId: string,
    taskId: string,
    params?: BotTaskExportTaskTranscriptParams, options?: RequestInit) => Promise<botTaskExportTaskTranscriptResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    taskId: string,
    params?: BotTaskExportTaskTranscriptParams, options?: RequestInit) => {

        return customFetcher(getBotTaskExportTaskTranscriptUrl(botId,taskId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


